/** @jsx jsx */
import styled from "styled-components"
import { jsx, Styled } from "theme-ui"
import { Themed } from '@theme-ui/mdx'
import React from 'react'
import ButtonLink from "@components/ButtonLink"
import { Image } from "@theme-ui/components"
import Spacer from "@components/Spacers"


export default function PartnerLogos ({ heading, text, ctaButton, partners, supporters }) {
    return (
        <div sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            padding: " 0 5vw 0 5vw"
        }}>
            <Themed.h2>{heading}</Themed.h2>
            <Themed.p>{text}</Themed.p>
            {ctaButton && (
                <>
                    <Spacer.Small />
                    <ButtonLink to={ctaButton?.link}>
                        {ctaButton?.label}
                    </ButtonLink>
                </>)}
            <Spacer.Small />
            {partners.length > 0 && (
                <>
                    <Themed.h3>Partners</Themed.h3>
                    <div sx={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        justifyContent: "space-evenly",
                        padding: "0 5vw",
                        maxWidth: "1500px",
                        margin: "auto"
                    }}>
                        {partners.map((logo) => <Image sx={{
                            width: "33%",
                            height: "160px !important",
                            objectFit: "contain",
                        }} src={logo.image} />)}
                    </div>
                </>
            )
            }
            <Spacer.Small />
            {
                supporters.length > 0 && (
                    <>
                        <Themed.h3>Supporters</Themed.h3>
                        <div sx={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            justifyContent: "space-evenly",
                            padding: "0 5vw",
                            maxWidth: "1500px",
                            margin: "auto"
                        }}>
                            {supporters.map((logo) => <Image sx={{
                                width: "25%",
                                height: "80px !important",
                                objectFit: "contain",
                            }} src={logo.image} />)}
                        </div>
                    </>
                )
            }
            <Spacer.Medium />
        </div >
    )
}
